import useStripeProducts from "./useStripeProducts"

export default function withStripeProducts(Component) {
  return (props) => {
    const [stripeProducts] = useStripeProducts()
    return <Component stripeProducts={stripeProducts} {...props} />
  }
}
